const o = {
  name: "Andorra",
  dimensions: { width: 21, height: 21 },
  content: `
    <g>
      <path d="M1.25977 19.5875H19.2598V4.58752L16.2598 1.58752L13.2598 4.58752V12.5875L9.25977 10.5875L5.25977 12.5875V14.5875H3.25977L1.25977 16.5875V19.5875Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13.2598 12.5875V19.5875" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.25977 12.5875V19.5875" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  `
};
export {
  o as Andorra
};
